import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Inject,
  Input,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import moment from 'moment';
import { DifferentDateFormatPicker } from './rx-datepicker-directive';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MM/DD/YYYY',
    monthYearA11yLabel: 'MM/DD/YYYY',
  },
};
@Component({
  selector: 'rx-datepicker',
  templateUrl: './rx-datepicker.component.html',
  styleUrls: ['./rx-datepicker.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxDatepickerComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RxDatepickerComponent),
      multi: true,
    },
    { provide: MAT_DATE_FORMATS, useClass: DifferentDateFormatPicker },
  ],
})
export class RxDatepickerComponent implements AfterViewInit, ControlValueAccessor, Validator {
  public value = '';

  public month: number | string = '1';

  public dateRegex =
    /^02\/(?:[01]\d|2\d)\/(?:19|20)(?:0[048]|[13579][26]|[2468][048])|(?:0[13578]|10|12)\/(?:[0-2]\d|3[01])\/(?:19|20)\d{2}|(?:0[469]|11)\/(?:[0-2]\d|30)\/(?:19|20)\d{2}|02\/(?:[0-1]\d|2[0-8])\/(?:19|20)\d{2}$/;

  onChange: (value?: any) => void;

  onTouch: (event: any) => void;

  @Input() placeholder = '';

  @Input() ariaLabelledBy = '';

  @Input() autoFocus = false;

  @Input() hasError = false;

  @Input() format: string;

  @Input() isDisabled: boolean;

  @Input() inputType: any;

  @Input() isEuDatetimeFormat = true;

  @Input() newDateFormat = false;

  @Input() edit: boolean;

  @Input() fxFlex;

  @Input()
  public keepPlaceholder = false;

  @Input()
  public maxDate: Date | any = new Date();

  @Input()
  public minDate: Date | any = new Date('1900-01-01');

  @Input()
  public startView: any = 'month';

  @Input() startDate = new Date();

  @ViewChild('input', { static: false }) input: ElementRef;

  public control: FormControl;

  public currentInputValue: string;

  constructor(
    @Inject(MAT_DATE_FORMATS)
    public config: DifferentDateFormatPicker,
    public cd: ChangeDetectorRef,
  ) {}

  ngAfterViewInit() {
    this.config.setParse(this.format);
    if (this.autoFocus) {
      this.onFocus();
    }
  }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.onChange(moment(this.value, this.format));
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisableState(status: boolean) {
    this.isDisabled = status;
  }

  keyPressNumbers(event) {
    if (!/[0-9-_\/\. ]/.test(event.key)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  public isValid(): boolean {
    return this.control && !this.control.pending && !this.control.errors && !this.control.invalid;
  }

  // validate
  public validate(control: FormControl): ValidationErrors | any {
    this.control = control;

    return control.valid ? null : control.errors;
  }

  onInput(event) {
    this.currentInputValue = event.target.value;
    if (this.onChange && !event.target.value) {
      this.onChange(event.target.value);
    }
  }

  addEventChange(event: any) {
    if (!event?.value) {
      return;
    }

    this.month = event.value.format('M').toString();
    this.setMonth(this.month);
    this.value = event.value;
    this.onChange(
      this.currentInputValue || event.value
        ? moment(event.value, this.format)
        : this.currentInputValue,
    );
  }

  onTouched(value) {
    if (this.onTouch) {
      this.onTouch(value);
    }
  }

  onFocus() {
    this.input.nativeElement.focus();
  }

  public setMonth(month) {
    if (month === '6' || month === '7') {
      this.config.setFormat('long');
    } else {
      this.config.setFormat('short');
    }
  }
}
